import { useSddTailoredData } from './useSddTailoredData';

export const useSddDeliveryStatus = () => {
    const { product, isLoading, isError, streetAddress, availableStock, isDoorDashAvailable } = useSddTailoredData();

    return {
        isError,
        isLoading,
        streetAddress,
        availableStock,
        isDoorDashAvailable,
        minimumCaseQty: product?.deliveryMethods?.SDD?.purchaseQuantities?.min ?? 1,
    };
};
